import type { UpdateCommunicationPreferenceCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useEnumOptions } from '../../hooks/useEnumOptions'
import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey =
  typeUtils.createValidator<UpdateCommunicationPreferenceCommandData>()

export const UpdateCommunicationPreferenceForm = (
  props: CommandDataFormProps<UpdateCommunicationPreferenceCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const informationSources = useHook('pages.crm.useCrmInformationSources')()
  const communicationPreferenceTypes = useEnumOptions(
    'CommunicationPreferenceType',
    'crm',
  )

  return (
    <FormikForm
      initialValues={{
        _type: 'UpdateCommunicationPreferenceCommandData',
      }}
      {...props}
    >
      <FormikDatePicker
        name={validateKey('changeDate')}
        label={translate('updateCommunicationPreference.field.changeDate')}
      />
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
      <FormikSelect
        name={validateKey('communicationPreferenceType')}
        label={translate(
          'updateCommunicationPreference.field.communicationPreferenceType',
        )}
        options={communicationPreferenceTypes}
        renderFn={(x) =>
          translateEnum('legalEntity.enum.CommunicationPreferenceType', x)
        }
      />
    </FormikForm>
  )
}
